import FuzzySearch from 'fuzzy-search';
import {useMemo} from 'react';
import accents from 'remove-accents';
import {GenericFilterItemGroup} from './types';

export const useFilterItemGroups = ({
  itemGroups,
  search,
}: {
  itemGroups?: Array<GenericFilterItemGroup>;
  search: string;
}) => {
  return useMemo(() => {
    if (!itemGroups?.length) return [];
    if (search === '') return itemGroups;

    return itemGroups.reduce((filteredItemGroups, group) => {
      const {items, groupLabel} = group;

      const filteredItems = items.filter(data => {
        const label = data.label.toLocaleLowerCase();
        const labelWithoutAccents = accents.remove(label);

        const searcher = new FuzzySearch([label, labelWithoutAccents], [], {
          caseSensitive: false,
          sort: true,
        });
        const foundResultInFuzzySearch =
          searcher.search(search.toLowerCase()).length > 0;

        return (
          label.includes(search.toLowerCase()) ||
          labelWithoutAccents.includes(search.toLowerCase()) ||
          foundResultInFuzzySearch
        );
      });

      return filteredItems.length === 0
        ? filteredItemGroups
        : [
            ...filteredItemGroups,
            {
              items: filteredItems,
              groupLabel,
            },
          ];
    }, [] as Array<GenericFilterItemGroup>);
  }, [itemGroups, search]);
};
